import React from 'react';
import { CurrencyInput } from 'components/UI';

function MoneyInputComponent(props) {
  return <CurrencyInput {...props} />;
}

export default MoneyInputComponent;
